import * as React from 'react';
import EmbedCalendarWoo from '../components/EmbedCalendarWoo';

const WooCalendarScreen: React.FunctionComponent = () => {
  return (
    <div>
      <EmbedCalendarWoo />
    </div>
  );
};

export default WooCalendarScreen;
